<template lang="pug">
#modal-editar-laudos-vinculados
    el-dialog(
        width='80%',
        title='Editar laudos vinculados',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        h3.center Empresa: {{ empresa.nomeEmpresa }}
        main
            .modal-editar-laudos-vinculados__desabilitados
                h3 Desabilitados
                el-card(shadow='never', :body-style='{ padding: "10px" }')
                    el-table.box-card(
                        ref='tabelaDesabilitados',
                        :data='laudosDesabilitadosFiltrados',
                        size='mini',
                        height='350px',
                        @selection-change='alterarLaudosDesabilitadosSelecionados'
                    )
                        el-table-column(type='selection', width='50')
                        el-table-column(
                            label='Nome',
                            prop='nome',
                            sortable,
                            :min-width='100'
                        )
                        el-table-column(align='right')
                            template(slot='header', slot-scope='scope')
                                el-input(
                                    v-model='filtroLaudosDesabilitados',
                                    size='mini',
                                    placeholder='Pesquisar'
                                )

                    footer.mt-2
                        span {{ laudosDesabilitadosSelecionados.length }} {{ laudosDesabilitadosSelecionados.length === 1 ? 'laudo selecionado' : 'laudos selecionados' }}

            el-button-group
                BaseButton(
                    type='primary',
                    icon='el-icon-arrow-left',
                    size='medium',
                    @click='desabilitarLaudos'
                )
                BaseButton(
                    type='primary',
                    icon='el-icon-arrow-right',
                    size='medium',
                    @click='habilitarLaudos'
                )

            .modal-editar-laudos-vinculados__habilitados
                h3.mb-3
                    | Habilitados

                el-card(shadow='never', :body-style='{ padding: "10px" }')
                    el-table.box-card(
                        ref='tabelaHabilitados',
                        :data='laudosHabilitadosFiltrados',
                        size='mini',
                        height='350px',
                        @selection-change='alterarLaudosHabilitadosSelecionados'
                    )
                        el-table-column(type='selection', width='50')
                        el-table-column(
                            label='Nome',
                            prop='nome',
                            sortable,
                            :min-width='100'
                        )
                        el-table-column(align='right')
                            template(slot='header', slot-scope='scope')
                                el-input(
                                    v-model='filtroLaudosHabilitados',
                                    size='mini',
                                    placeholder='Pesquisar'
                                )

                    footer.mt-2
                        span {{ laudosHabilitadosSelecionados.length }} {{ laudosHabilitadosSelecionados.length === 1 ? 'laudo selecionado' : 'laudos selecionados' }}

        footer(slot='footer')
            BaseButton(size='mini', @click='fechar') Cancelar
            BaseButton(size='mini', type='primary', @click='vincularLaudos') Confirmar
</template>

<script>
import LaudoEmpresaService from '@/services/LaudoEmpresaService';
import BaseButton from '@/components/vegaComponents/BaseButton';

export default {
    name: 'ModalEditarLaudosVinculados',
    components: {
        BaseButton
    },
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },
        empresa: {
            type: Object,
            required: true
        },
        laudos: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            filtroLaudosDesabilitados: '',
            filtroLaudosHabilitados: '',
            laudosDesabilitados: [],
            laudosHabilitados: [],
            laudosDesabilitadosSelecionados: [],
            laudosHabilitadosSelecionados: []
        };
    },

    computed: {
        laudosDesabilitadosFiltrados() {
            return this.laudosDesabilitados.filter(laudo =>
                laudo.nome
                    .toLowerCase()
                    .includes(this.filtroLaudosDesabilitados.toLowerCase())
            );
        },

        laudosHabilitadosFiltrados() {
            return this.laudosHabilitados.filter(laudo =>
                laudo.nome
                    .toLowerCase()
                    .includes(this.filtroLaudosHabilitados.toLowerCase())
            );
        }
    },

    watch: {
        mostrar() {
            if (this.mostrar) {
                this.buscarLaudosHabilitados();
            }
        }
    },

    methods: {
        async buscarLaudosHabilitados() {
            const { data } = await LaudoEmpresaService.buscarLaudosPorEmpresa(
                this.empresa.idEmpresa
            );

            this.laudosHabilitados = data.itens;

            const codigosLaudosHabilitados = this.laudosHabilitados.map(
                ({ codigo }) => codigo
            );

            this.laudosDesabilitados = this.laudos.filter(
                ({ codigo }) => !codigosLaudosHabilitados.includes(codigo)
            );
        },

        fechar() {
            this.filtroLaudosDesabilitados = '';
            this.filtroLaudosHabilitados = '';
            this.laudosDesabilitadosSelecionados = [];
            this.laudosHabilitadosSelecionados = [];

            this.limparSelecoes();

            this.$emit('fechar');
        },

        alterarLaudosDesabilitadosSelecionados(linhas) {
            this.laudosDesabilitadosSelecionados = linhas;
        },

        alterarLaudosHabilitadosSelecionados(linhas) {
            this.laudosHabilitadosSelecionados = linhas;
        },

        limparSelecoes() {
            this.$refs.tabelaDesabilitados.clearSelection();
            this.$refs.tabelaHabilitados.clearSelection();
        },

        habilitarLaudos() {
            this.laudosHabilitados = [
                ...this.laudosHabilitados,
                ...this.laudosDesabilitadosSelecionados
            ];

            const codigosLaudosHabilitados = this.laudosHabilitados.map(
                ({ codigo }) => codigo
            );

            this.laudosDesabilitados = this.laudos.filter(
                ({ codigo }) => !codigosLaudosHabilitados.includes(codigo)
            );

            this.limparSelecoes();
        },

        desabilitarLaudos() {
            this.laudosDesabilitados = [
                ...this.laudosDesabilitados,
                ...this.laudosHabilitadosSelecionados
            ];

            const codigosLaudosDesabilitados = this.laudosDesabilitados.map(
                ({ codigo }) => codigo
            );

            this.laudosHabilitados = this.laudos.filter(
                ({ codigo }) => !codigosLaudosDesabilitados.includes(codigo)
            );

            this.limparSelecoes();
        },

        async vincularLaudos() {
            const idsLaudos = this.laudosHabilitados.map(({ id }) => id);
            try {
                await LaudoEmpresaService.vincularLaudosEmpresa(
                    this.empresa.idEmpresa,
                    idsLaudos
                );
                this.$emit('atualizar-tabela');
                this.$notify.success({ message: 'Laudos vinculados' });
                this.fechar();
            } catch (error) {
                this.$notify.error({
                    message: 'Ocorreu um erro ao vincular os laudos à empresa'
                });
            }
        }
    }
};
</script>
<style lang="scss">
#modal-editar-laudos-vinculados {
    main {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;

        footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    footer {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }

    .modal-editar-laudos-vinculados__desabilitados,
    .modal-editar-laudos-vinculados__habilitados {
        width: 40%;

        h3 {
            display: flex;
            font-size: 16px;
            justify-content: space-between;
            align-items: center;
            height: 28px;
        }
    }

    .center {
        text-align: center;
        display: block;
        font-weight: 600;
        color: var(--primary);
        padding-bottom: 10px;
    }
}
</style>
